module.exports = __webpack_public_path__ + "media/נחש.05d27941.mp3";